<div class="row row-padding-bottom" *ngIf="hasUserData">
  <div class="column medium-12">
      <span class="float-right icons" (click)="exportToExcel()">
        <i class="icon ion-ios-cloud-download-outline"></i>
      </span>
  </div>
  <div class="medium-12 indy-tables badge-tables">
    <div class="row no-hover client-todos tax-strategy client-plans" style="height: 75vh;overflow-y: auto;">
      <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
        <table style="margin-top: 0 !important;">
          <thead>
          <tr>
            <th class="pointer" (click)="columnSort(column, columns)" *ngFor="let column of columns" attr.sortable="{{column['sortable'] == true}}">
              <span>{{column.title}}</span>
              <span class="float-right">
            <span *ngIf="column.sortType == 'asc'">
              <i class="icon ion-ios-arrow-up sort-indicator"></i>
            </span>
            <span *ngIf="column.sortType == 'desc'">
              <i class="icon ion-ios-arrow-down sort-indicator"></i>
            </span>
          </span>
            </th>
            <th class="pointer"></th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="userTableData && userTableData.length == 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                  <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="userTableData && userTableData.length > 0">
            <tr *ngFor="let row of userTableData">
              <td *ngFor="let col of columns;let idx=index">
                <div class="pointer" *ngIf="col.name == 'userName'" (click)="openInstancePage(row)">{{row[col.name]}}</div>
                <div class="pointer text-center" *ngIf="col.name == 'submittedEnhancements' || col.name == 'submittedBugs' || col.name == 'submittedHelps'" (click)="showFeedbackReport(row, col)">{{row[col.name]}}</div>
                <div class="pointer" [ngClass]="(col.name == 'email' || col.name == 'firmName') ? '' : 'text-center'" *ngIf="col.name != 'userName' && col.name != 'submittedEnhancements' && col.name != 'submittedBugs' && col.name != 'submittedHelps'">{{row[col.name]}}</div>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
